import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import SmartCreateFeedbackBannerQuery from './__generated__/SmartCreateFeedbackBannerQuery.graphql.ts';

export function preloadSmartCreateFeedbackBanner(contentId: string): Promise<{
	data: unknown;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query({
		query: SmartCreateFeedbackBannerQuery,
		variables: {
			contentId,
		},
	});
}
